<app-patient-info [heading]="Item"></app-patient-info>
<p-table
  *ngIf="allergies"
  [responsive]="true"
  [columns]="selectedColumns"
  [value]="allergies.data"
  selectionMode="single"
  dataKey="allergyId"
  [resetPageOnSort]="false"
  [lazy]="false"
  [rows]="rows"
  [paginator]="showRecords"
  (sortFunction)="customSort($event, 1)"
  [customSort]="true"
>
  <ng-template pTemplate="caption">
    <div class="formgroup-inline col-12 pb-0">
      <div class="field pt-1">
        <p-multiSelect
          [options]="cols"
          [(ngModel)]="selectedColumns"
          optionLabel="header"
          contenteditable="false"
          [showToggleAll]="true"
          selectedItemsLabel="{0} columns selected"
          [style]="{ minWidth: '200px' }"
          placeholder="Choose Columns"
        ></p-multiSelect>
      </div>
      <div class="field col-5 pb-0 pt-1">
        <label htmlfor="txtAllergySerach" class="p-sr-only"
          >Enter your search</label
        >
        <input
          pinputtext=""
          id="txtAllergySerach"
          type="text"
          placeholder="Enter your search"
          class="text-base text-color p-2 w-12"
          [(ngModel)]="txtSearch"
          style="width: auto; height: 37px"
        />
      </div>
      <div class="pb-0 pt-1 BH">
        &nbsp;
        <button
          pButton
          type="button"
          icon="pi pi-search"
          label="Search"
          (click)="searchAllergies()"
          class="loginbtn"
        ></button>
        &nbsp;<p-button
          label="Clear"
          severity="secondary"
          (click)="clearSearch()"
          icon="pi pi-refresh"
        ></p-button>
        &nbsp;
        <button
          pButton
          type="button"
          icon="pi pi-print"
          label="Print"
          class="p-button-plain"
          (click)="printAllergies()"
          title="Print Allergies"
          *ngIf="setPrintFlag"></button
        >&nbsp;
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr *ngIf="showRecords == true">
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-rowData
    let-columns="columns"
    let-i="rowIndex"
  >
    <tr [pSelectableRow]="rowData">
      <td *ngFor="let col of columns">
        {{ rowData[col.field] }}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <div class="w-12 bg-white">
      <div class="" style="text-align: center">
        <img
          _ngcontent-ng-c683320295=""
          class="profile-image"
          style="border-radius: 50%; width: 10rem; padding-top: 1rem"
          src="assets/imagesNew/table_error.png"
        />
      </div>
      <hr style="margin-bottom: 0.5rem" />
      <div class=""
           style="text-align: center; font-size: larger; color: #1d428f">
          <i>No records found</i>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="paginatorleft" let-state>

      <span *ngIf="state.totalRecords > pageSize">
          Showing {{ state.page * state.rows + 1 }} to
          {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
      </span>
  </ng-template>
</p-table>

<!-- Print functionality  for Allergies_ List -->
<div
  class="panel table-responsive"
  id="PrintAllergies_List"
  style="display: none"
>
  <div
    style="
      display: flex;
      background-color: #ffffff;
      margin-bottom: 1.5%;
      padding: 0.5%;
    "
  >
    <div
      style="
        display: flex;
        justify-content: left;
        align-items: center;
        width: 50%;
      "
    >
      <span>Allergies:&nbsp;</span>
    </div>
    <div
      style="
        display: flex;
        justify-content: right;
        align-items: center;
        width: 50%;
      "
    >
      <span
        ><strong>{{ patientFullName }}</strong></span
      >
    </div>
  </div>

  <div
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0% 0% 0% 0%;
    "
  >
    <table
      style="width: 100%; border-collapse: collapse; border: 1px solid grey"
      id="Allergies_print_table_tbody"
    >
      <thead
        style="
          background-color: #142066;
          border: 0px solid #808080;
          color: snow;
        "
      >
        <tr>
          <th
            *ngFor="let col of _selectedColumns"
            style="border: 1px solid #808080; text-align: left"
          >
            {{ col.header }}
          </th>
        </tr>
      </thead>
      <tbody id="Allergies_print_table_tbody">
        <tr
          *ngFor="let item of allergies?.data"
          style="border: 1px solid #808080"
        >
          <td
            *ngFor="let col of _selectedColumns"
            style="
              text-align: left;
              border: 1px solid #808080;
              padding: 0.5% 0% 0.5% 0%;
            "
          >
            {{ item[col.field] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="allergies?.data.length == 0"
       class="alert alert-warning"
       role="alert"
       style="text-align: center">
      <span class="glyphicon glyphicon-exclamation-sign"
            aria-hidden="true"></span>
      <span class="sr-only">Error:</span>
      <i>No records found</i>
  </div>
</div>
